import React, { useEffect, useState } from "react";
import { Row, Col, Typography } from "antd";
import { getFirestore, collection, getDocs, query } from "firebase/firestore";
import { Link } from "react-router-dom";
import CustomSectionCard from "../CustomSectionCard/CustomSectionCard";
import "./Categories.scss";

const { Text } = Typography;

const Categories = () => {
  const [categoriesData, setCategoriesData] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const db = getFirestore();
        const categoriesCollection = collection(db, "categorias");
        const q = query(categoriesCollection);
        const categoriesSnapshot = await getDocs(q);

        const categories = categoriesSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
          habilitada: doc.data().habilitada !== undefined ? doc.data().habilitada : true,
        }));

        // Primero las activas y después las "Próximamente" (sort es estable: conserva el orden dentro de cada grupo)
        categories.sort((a, b) => Number(b.habilitada !== false) - Number(a.habilitada !== false));

        setCategoriesData(categories);
      } catch (error) {
        console.error("Error al obtener categorías:", error);
      }
    };
    fetchCategories();
  }, []);

  return (
    <div className="categories-section">
      <CustomSectionCard
        title="Categorías populares"
        subtitle="Encuentra exactamente lo que necesitas"
      >
        <Row gutter={[{ xs: 8, sm: 16, md: 24 }, { xs: 8, sm: 16, md: 24 }]}>
          {categoriesData.map((category) => {
            const estaHabilitada = category.habilitada !== false;

            if (estaHabilitada) {
              return (
                <Col key={category.id} xs={8} sm={8} md={6} lg={4} xl={3}>
                  <Link
                    to={`/buscador?tipo=${category.tipo}&categoria=${category.id}`}
                    className="category-item-link"
                  >
                    <div className="category-circle-card">
                      <div className="category-image-wrapper">
                        <img alt={category.nombre} src={category.photo} />
                      </div>
                      <Text className="category-name" ellipsis>
                        {category.nombre}
                      </Text>
                    </div>
                  </Link>
                </Col>
              );
            }

            return (
              <Col key={category.id} xs={8} sm={8} md={6} lg={4} xl={3}>
                <div
                  className="category-item-link category-disabled"
                >
                  <div className="category-circle-card">
                    <div className="category-image-wrapper">
                      <img
                        alt={category.nombre}
                        src={category.photo}
                        style={{ filter: "grayscale(100%)", opacity: 0.5 }}
                      />
                    </div>
                    <Text className="category-name category-disabled-text" ellipsis>
                      {category.nombre}
                    </Text>
                    <Text className="category-soon-text" ellipsis>
                      Próximamente
                    </Text>
                  </div>
                </div>
              </Col>
            );
          })}
        </Row>
      </CustomSectionCard>
    </div>
  );
};

export default Categories;